import {Helpers} from "../helpers/helpers";
import {ResourceList} from "./resource-list";

export class ResourceListFactory {
	public constructor() {
		ResourceListFactory.createIndividualResourcePagesList();
		ResourceListFactory.createAllResourcesPage();
	}

	//pages such as /resources/videos
	private static createIndividualResourcePagesList() {
		if (Helpers.elementExists(".resource-type-list")) {
			new ResourceList(`.resource-type-list`);
		}
	}

	//the root /resources page that is multiple widgets. 
	private static createAllResourcesPage() {
		if (Helpers.elementExists(".resource-list")) {
			let resourceLists: ResourceList[] = [];
			document.querySelectorAll(".section-content .resource-section").forEach(c => {
				const selector = Array.from(c.classList).find(c => c.indexOf('section-type-') !== -1);
				if (selector) {
					resourceLists.push(new ResourceList(`.resource-section.${selector}`, (results) => {
						const initValue = 0;
						const total = resourceLists.reduce((sum, obj) => sum + obj.totalResults, initValue); //sum results of all resource lists
						resourceLists[0].updateTotalResultsElement(total);
					}, 3));
				}
			});
		}
	}
}